import React from 'react';
import './Returns.css';

const Returns = () => {
  const returns = [];

  if (returns.length === 0) {
    return (
      <div className="returns">
        <div className="returns__empty">
          <p className="returns__empty-text">
            No tienes solicitudes de devolución.
          </p>
          <p className="returns__empty-subtext">
            Si necesitas devolver un producto, contáctanos a través de nuestro servicio de atención al cliente.
          </p>
          <a href="/contacto" className="returns__btn">
            Contactar
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="returns">
      <div className="returns__list">
        {returns.map((returnItem) => (
          <div key={returnItem.id} className="returns__item">
            <div className="returns__item-header">
              <span className="returns__return-id">Devolución #{returnItem.id}</span>
              <span className={`returns__status returns__status--${returnItem.status}`}>
                {returnItem.status}
              </span>
            </div>
            <div className="returns__item-body">
              <p className="returns__product">{returnItem.product}</p>
              <p className="returns__reason">{returnItem.reason}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Returns;
